import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// 📥 Importar páginas
import Login from "./pages/Login";
import Registration from "./pages/Registration";
import Perfil from "./pages/Perfil";
import Notificaciones from "./pages/NotificacionesPage";
import AdminScenathon from "./pages/AdminScenathon";
import MainLayout from "./Main/MainLayoud";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiesPolicy from "./pages/CookiesPolicy";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SubmissionPage from "./pages/Submission";
import InitialSubmissionPage from "./pages/InitialSubmission";
import ScenathonLobby from "./pages/ScenathonLobby";
import TradeAdjustmentPage from "./pages/TradeAdjustment";
import DataTradeAdjustmentPage from "./pages/DataTradeAdjustment";
import { NotificationsProvider } from "./components/Notificaciones/NotificationsContext";

// 📥 Importar Auth
import { AuthProvider } from "./auth/AuthContext";
import RequireAuth from "./auth/RequireAuth";
import RequireRole from "./auth/RequireRole"; // 🆕 NUEVO

import "./App.css";

// Wrapper para pasar headerText al layout
function LayoutWrapper({ headerText }) {
  return <MainLayout headerText={headerText} />;
}

function App() {
  return (
    <AuthProvider>
      <NotificationsProvider>
        <BrowserRouter>
          <Routes>
            {/* ========================================
                🟢 RUTAS PÚBLICAS (sin autenticación)
                ======================================== */}
            <Route path="/" element={<Login />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/terminos" element={<TermsAndConditions />} />
            <Route path="/privacidad" element={<PrivacyPolicy />} />
            <Route path="/cookies" element={<CookiesPolicy />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* ========================================
                🔒 RUTAS PROTEGIDAS (requieren token)
                ======================================== */}

            {/* Rutas para TODOS los usuarios autenticados */}
            <Route element={<RequireAuth />}>
              {/* Profile y Notifications - accesibles por todos */}
              <Route element={<LayoutWrapper headerText="Profile" />}>
                <Route path="/perfil" element={<Perfil />} />
              </Route>

              <Route element={<LayoutWrapper headerText="Notifications" />}>
                <Route path="/notificaciones" element={<Notificaciones />} />
              </Route>

              {/* Scenathon - accesible por todos */}
              <Route element={<LayoutWrapper headerText="Welcome to Scenathon Platform Dashboard" />}>
                <Route path="/initial-submission" element={<InitialSubmissionPage />} />
                <Route path="/submission" element={<SubmissionPage initialTab="submission" />} />
                <Route path="/dashboard" element={<SubmissionPage initialTab="dashboard" />} />
              </Route>

              <Route path="/lobby" element={<ScenathonLobby />} />

              {/* Trade Adjustment - accesible por organizer y admin */}
              <Route element={<LayoutWrapper headerText="Welcome to Scenathon Platform Dashboard" />}>
                <Route path="/trade-adjustment" element={<TradeAdjustmentPage />} />
              </Route>

              {/* Data Trade Adjustment - accesible por organizer y admin */}
              <Route element={<LayoutWrapper headerText="Welcome to Scenathon Platform Dashboard" />}>
                <Route path="/data-trade-adjustment" element={<DataTradeAdjustmentPage />} />
              </Route>
            </Route>

            {/* ========================================
                🛡️  RUTAS SOLO PARA ADMIN
                ======================================== */}
            <Route element={<RequireAuth />}>
              <Route element={<RequireRole requiredRoles="admin" />}>
                <Route element={<LayoutWrapper headerText="Administration of the Scenathon Platform" />}>
                  <Route path="/admin/scenathon" element={<AdminScenathon />} />
                </Route>
              </Route>
            </Route>

            {/* ========================================
                404: Ruta no encontrada
                ======================================== */}
            <Route path="*" element={<div>Page not found</div>} />
          </Routes>
        </BrowserRouter>
      </NotificationsProvider>
    </AuthProvider>
  );
}

export default App;